"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _getLayoutType = require("./functions/getLayoutType");

var _events = require("./functions/events");

var _onResize = require("./functions/onResize");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var $ = _jquery["default"];
var WDHBuilder = {
  _instance: null,
  getInstance: function getInstance() {
    var _this = this;

    if (this.instance) {
      this.instance = {
        $mainContainer: null,
        determineSectionCallback: null,
        defaultContainerName: 'header-container-',
        defaultContainerNameIndex: 0,
        sections: {},
        currentSection: null,
        createDefaultContainerName: function createDefaultContainerName() {
          _this.defaultContainerNameIndex += 1;
          return "".concat(_this.defaultContainerName).concat(_this.defaultContainerNameIndex);
        },
        buildSection: function buildSection(label) {
          _this.sections[label] = [];

          var $mainSectionContainer = _this.createContainer("".concat(label, "-section"));

          $mainSectionContainer.hide();

          _this.addToContainer($mainSectionContainer, _this.$mainContainer);

          _this.sections[label].push($mainSectionContainer);

          if (_this.section.containers) {
            _this.section.containers.forEach(function (containerData) {
              var $subContainer;

              if (!containerData.className && !containerData.id) {
                containerData.className = _this.createDefaultContainerName();
              }

              var $container = _this.createContainer(containerData.className, containerData.id);

              if (containerData.containers) {
                containerData.containers.forEach(function (subContainerData) {
                  if (!subContainerData.className) {
                    subContainerData.className = _this.createDefaultContainerName();
                  }

                  $subContainer = _this.createContainer(subContainerData.className, containerData.id);

                  _this.addToContainer($subContainer, $('> .inner-container', $container));

                  if (subContainerData.components) {
                    subContainerData.components.forEach(function ($component) {
                      _this.addToContainer($component.clone(true), $('> .inner-container', $subContainer));
                    });
                  }
                });
              }

              if (containerData.components) {
                containerData.components.forEach(function ($component) {
                  _this.addToContainer($component.clone(true), $('> .inner-container', $container));
                });
              }

              _this.addToContainer($container, $('> .inner-container', $mainSectionContainer));
            });
          }
        },
        createContainer: function createContainer(className, id) {
          return $("<div id=\"".concat(id || '', "\" class=\"").concat(className || '', " outer-container\"><div class=\"inner-container\"></div></div>"));
        },
        addToContainer: function addToContainer($element, $container) {
          $container.append($element);
        },
        clearMainContainer: function clearMainContainer() {
          // $mainContainer.empty();
          this.$mainContainer.children().hide();
        },
        hasSection: function hasSection(section) {
          return this.sections[section];
        },
        displaySection: function displaySection(section) {
          if (section !== this.currentSection) {
            this.currentSection = section;

            if (this.sections[section]) {
              this.clearMainContainer();
              this.sections[section].forEach(function ($container) {
                // addToContainer($container, $mainContainer);
                $container.show();
              });
              $('.component', this.$mainContainer).addClass('component-ready animate');
            }
          }
        },
        determineSuitableSection: function determineSuitableSection() {
          var section = (0, _getLayoutType.getLayoutType)();
          var implementationSpecificOverrideSection;

          if (!this.hasSection(section)) {
            section = _getLayoutType.DESKTOP_LAYOUT;
          }

          if (this.determineSectionCallback) {
            implementationSpecificOverrideSection = this.determineSectionCallback.apply(null, [section]);

            if (implementationSpecificOverrideSection) {
              return implementationSpecificOverrideSection;
            }
          }

          return section;
        },
        build: function build(settings) {
          var _this2 = this;

          // save main container
          if (!settings.mainContainer) throw new Error("Can't build component. No 'mainContainer' defined.");
          this.$mainContainer = settings.mainContainer;
          this.determineSectionCallback = settings.determineSectionCallback; // build sections

          if (settings.sections) {
            $.each(settings.sections, this.buildSection);
          } // display desktop


          this.displaySection(this.determineSuitableSection());
          setTimeout(function () {
            (0, _events.triggerEvent)(_events.EVENTS.BUILDER_DONE, settings);
          }, 0); // setup resizer handler

          (0, _onResize.onResize)(function () {
            _this2.displaySection(_this2.determineSuitableSection());
          });
        }
      };
    }

    return this.instance;
  }
};
var _default = WDHBuilder;
exports["default"] = _default;